import { render, staticRenderFns } from "./recipe-no-results.vue?vue&type=template&id=c14a273a&"
import script from "./recipe-no-results.vue?vue&type=script&lang=js&"
export * from "./recipe-no-results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports